import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';
import { ActivityLog, ActivityLogListResponseDTO } from '../entities';

const activityLogListResponseDTOToActivityLogListDataAdapter = (data: ActivityLogListResponseDTO): ActivityLog[] => {
  if (!data.body) {
    throw new Error('Error');
  }

  const { activityLog } = data.body;

  if (isEmpty(activityLog)) {
    return [];
  }

  return activityLog;
};

export { activityLogListResponseDTOToActivityLogListDataAdapter };
